import type { GetQuestionReviewTaskByIdQuery } from '@exam-management/graphql';

type QuestionReviewSubtask =
  GetQuestionReviewTaskByIdQuery['wflGetTaskById']['task']['subtasks'][number];

function extractParts(code: string) {
  const parts = code.split('-');
  return { xx: parseInt(parts[1], 10), yy: parseInt(parts[2], 10) };
}

export function sortTaskByCode(
  currentTask: QuestionReviewSubtask,
  candidateTask: QuestionReviewSubtask,
) {
  const a = extractParts(currentTask.code);
  const b = extractParts(candidateTask.code);

  return a.xx - b.xx || a.yy - b.yy;
}
